import { forwardRef } from 'react'
import { Box, Button, LinearProgress, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'

const SubmitButton = forwardRef((props, ref) => {
  const { children, label, loading, title, ...rest } = props
  const button = (
    <Button
      {...rest}
      disabled={rest.disabled || loading}
      ref={ref}
      sx={{
        ...(rest.sx ?? {}),
        position: 'relative',
        overflow: 'clip',
      }}
    >
      {loading && (
        <Box
          component="span"
          sx={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}
        >
          <LinearProgress sx={{ height: '2px' }} />
        </Box>
      )}
      <Box component="span" sx={{ position: 'relative' }}>
        {children ?? label}
      </Box>
    </Button>
  )
  return title ? <Tooltip title={title}>{button}</Tooltip> : button
})

SubmitButton.displayName = 'SubmitButton'

SubmitButton.propTypes = {
  label: PropTypes.string,
  loading: PropTypes.bool,
  title: PropTypes.string,
}

export default SubmitButton
